module.exports = require("compressorjs");